export default __webpack_public_path__ + "static/media/hero.34795857.svg";